import { useEffect, useState } from 'react';
import * as timeago from 'timeago.js';

import { formatShortDateTime } from '@/utils/dates';

import { Tooltip } from '../Tooltip';

import type { Props } from './types';

const TICK_MS = 30_000;

/**
 * How long ago something happened ("5 minutes ago"), kept counting while it's on
 * screen, with the exact time in a tooltip that keyboard users can reach too.
 */
function TimeAgo({ className, date }: Props) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((tick) => tick + 1), TICK_MS);
    return () => clearInterval(interval);
  }, []);

  const at = new Date(date);

  return (
    <Tooltip content={formatShortDateTime(at.toISOString())} focusable>
      <time className={className} dateTime={at.toISOString()}>
        {timeago.format(at)}
      </time>
    </Tooltip>
  );
}

export { TimeAgo };
